import { lazy } from 'react'
import { DashSwitch } from '@retailer-platform/dashboard/routing'
import { DomainRoute } from '../utils/domain/routingComponents'
import { caperTransactionsAccessControl } from '../access-control/connectedStoresAccess.configuration'
const ConnectedStoresCaperTransactionsPage = lazy(
  () => import('../pages/caper-transactions/ConnectedStoresCaperTransactionsPage')
)

export const connectedStoresRetailerRouter = (
  <DomainRoute route="app-retailer-scope-connected-stores">
    <DashSwitch>
      <DomainRoute
        exact
        route="app-retailer-scope-connected-stores-caper-transactions"
        component={ConnectedStoresCaperTransactionsPage}
        accessControl={caperTransactionsAccessControl}
      />
    </DashSwitch>
  </DomainRoute>
)
